module.exports = __webpack_public_path__ + "static/media/hw_ho_30.4e0236ee.flv";